import type { ChaliceStore } from '../types';

export const selectRecentSearches = (state: ChaliceStore) =>
  state.recentSearches.searches;
